import React, { useState, useEffect } from "react";
import { Box, Grid, Divider } from "@mui/material";
import { H3, H4, H5, Tiny } from "../../components/Typography";
import { load } from "../../constants/storage";
import * as Models from "../../models";
import { mfTransaction } from "../../redux/actions/TransactionAction";
import { useAppDispatch } from "../../store/hooks";
import moment from "moment";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../Api/EndPoints";
import InsertDots from "../../constants/InsertDots";

export default function MFTransaction() {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(true);
  const [mfData, setMfData] = React.useState([]);
  let navigate = useNavigate();

  useEffect(() => {
    getMFTransaction();
  }, []);

  const getMFTransaction = async () => {
    setLoading(true);
    let token = await load("token");
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const req: Models.MutualFundKYCRequestStatus = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
    };
    dispatch(mfTransaction(req, `bearer ${token}`))
      .then(async (response: any) => {
        setLoading(false);
        setMfData(response?.orders);
      })
      .catch((error: any) => {
        setLoading(false);
      });
  };

  const convertTimeDate = (value: any) => {
    if (value == null) {
      return "--";
    } else {
      let date = new Date(value);
      let transactionDate = moment(date).format("DD MMM YYYY hh:mm A");

      return transactionDate;
    }
  };
  return (
    <>
      {loading ? (
        <Grid
          height="100vh"
          display="flex"
          flexDirection="column"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Grid>
      ) : mfData?.length === 0 || mfData === undefined ? (
        <Grid
          height="85vh"
          display="flex"
          flexDirection="column"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <H3>No record found!</H3>
        </Grid>
      ) : (
        <Grid
          textAlign="center"
          justifyContent="center"
          height="100vh"
          sx={{ background: "#fff", mb: 2 }}
        >
          <Grid>
            {mfData?.map((item: any, index: any) => (
              <>
                <Grid
                  onClick={() =>
                    navigate("/transactiondetail", {
                      state: {
                        data: item,
                        screenname: "mutualfund",
                        status:
                          item.status === "PAYMENT_CONFIRMED"
                            ? "Success"
                            : item.status === "FAILED"
                            ? "Failed"
                            : "In Progress",
                      },
                    })
                  }
                  justifyContent="space-between"
                  sx={{ display: "flex", cursor: "pointer" }}
                >
                  {/* 1st */}
                  <Box
                    sx={{
                      display: "flex",
                      mt: 1, mb: 1,
                      p: { xs: 1, sm: 1, md: 1 },
                    }}
                  >
                    <Box
                      component="img"
                      src={
                        item?.fund_scheme?.logo
                          ? API_BASE_URL + item?.fund_scheme?.logo
                          : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/mf.svg"
                      }
                      sx={sxStyleImage}
                    />
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        marginLeft: 1.5,
                      }}
                    >
                      <H4 fontWeight={500} color="#141414" sx={text}>
                       
                        {item?.fund_scheme?.name}
                      </H4>
                      <H5 fontWeight={500} color="#141414" sx={{
                         fontFamily: "'Poppins', sans-serif",
                         display: {
                         md:'none',
                         xs:'flex'
                         },
                         fontSize: 12,
                         mt: 0.13,
                         fontWeight: "600",
                         textAlign:'left',
                      }}>
                       
                       {InsertDots(item?.fund_scheme?.name, 30)}
                     </H5>
                      <Grid alignItems="center" sx={{ display: "flex" }}>
                        <Tiny color="#747474" fontWeight={"400"} sx={{ mr: 1 ,fontFamily: "'Poppins', sans-serif",display:{
                          md:'none',
                          xs:'flex'
                        }}}>
                          {item?.type === "PURCHASE"
                            ? "Purchase"
                            : item?.type === "REDEEM_ALL"
                            ? "Full Redeem"
                            : item?.type === "ADDITIONAL_PURCHASE"
                            ? "Additional Purchase"
                            : "Partial Redeem"}
                        </Tiny>
                        <H5 color="#747474" fontWeight={"400"} sx={{ mr: 1 ,fontFamily: "'Poppins', sans-serif",display:{
                          md:'flex',
                          xs:'none'
                        }}}>
                          {item?.type === "PURCHASE"
                            ? "Purchase"
                            : item?.type === "REDEEM_ALL"
                            ? "Full Redeem"
                            : item?.type === "ADDITIONAL_PURCHASE"
                            ? "Additional Purchase"
                            : "Partial Redeem"}
                        </H5>
                        <Tiny color="#747474" fontWeight={"400"} sx={{ fontFamily: "'Poppins', sans-serif",display:{
                          md:'none',
                          xs:'flex'
                        }}}>
                          {convertTimeDate(item?.created_at)}
                        </Tiny>
                        <H5 color="#747474" fontWeight={"400"} sx={{ ml: 1 ,fontFamily: "'Poppins', sans-serif",display:{
                          md:'flex',
                          xs:'none'
                        }}}>
                          {convertTimeDate(item?.created_at)}
                        </H5>
                      </Grid>
                    </Box>
                  </Box>
                  {/* 2 nd */}
                  <Box
                    sx={{
                      display: "flex",
                      mt:  { xs: 0, sm: 1, md: 1 },
                      p: { xs: 2, sm: 1, md: 1 },
                     
                    }}
                  >
                    <Box
                     sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      flexDirection: "column",
                      alignItems:'flex-end',
                      mr:{
                        md:1,
                        xs:0
                      }
                    }}
                    >
                      <H4
                        fontWeight={600}
                        color={process.env.REACT_APP_PRIMARY_COLOR}
                      >
                        ₹{item?.amount ? item?.amount : "0.0"}
                      </H4>

                      <Tiny
                        color={
                          item?.status === "PAYMENT_CONFIRMED"
                            ? "#45A35F"
                            : item?.status === "SUCCESSFUL"
                            ? "#45A35F"
                            : item?.status === "PENDING"
                            ? "orange"
                            : item?.status === "SUBMITTED"
                            ? "#45A35F"
                            : "#FF0000"
                        }
                        fontWeight={"400"}
                        sx={{fontFamily: "'Poppins', sans-serif",display:{
                          md:'none',
                          xs:'flex'
                        }}}
                      >
                        {item?.status === "PAYMENT_CONFIRMED"
                          ? "Confirmed"
                          : item?.status === "PENDING"
                          ? "In Progress"
                          : item?.status?.charAt(0).toUpperCase() +
                            item?.status?.slice(1).toLowerCase()}
                      </Tiny>
                      <H5
                        color={
                          item?.status === "PAYMENT_CONFIRMED"
                            ? "#45A35F"
                            : item?.status === "SUCCESSFUL"
                            ? "#45A35F"
                            : item?.status === "PENDING"
                            ? "orange"
                            : item?.status === "SUBMITTED"
                            ? "#45A35F"
                            : "#FF0000"
                        }
                        fontWeight={"400"}
                        sx={{display:{
                          md:'flex',
                          xs:'none'
                        },fontFamily: "'Poppins', sans-serif"}}
                      >
                        {item?.status === "PAYMENT_CONFIRMED"
                          ? "Confirmed"
                          : item?.status === "PENDING"
                          ? "In Progress"
                          : item?.status?.charAt(0).toUpperCase() +
                            item?.status?.slice(1).toLowerCase()}
                      </H5>
                    </Box>
                  </Box>
                </Grid>
                <Divider />
              </>
            ))}
          </Grid>
        </Grid>
      )}
    </>
  );
}

const buttonStyle = {
  mt: 3,
  mb: 2,
  py: 1,
  fontFamily: "'Poppins', sans-serif",
  width: {
    xs: "100%",
    sm: "100%",
    md: "40%",
  },
  alignSelf: "center",
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
};
const text = {
  fontFamily: "'Poppins', sans-serif",
  display: {
  md:'flex',
  xs:'none'
  },
  fontSize: 15,
  mt: 0.13,
  fontWeight: "600",
  textAlign:'left'
};
const sxStyleImage = {
  height: {
    xs: 30,
    sm: 30,
    md: 40,
  },
  minwidth: {
    xs: 30,
    sm: 30,
    md: 30,
  },
  m: 0.6,
  mb: 0,
};
